import { BookOpen, CheckCircle } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const ImplementationGuide = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Implementation Guide
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            A comprehensive guide to implementing Scienza Health in your organization
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <Card className="p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-primary/10 p-3 rounded-lg">
                <BookOpen className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-2xl font-semibold">Getting Started</h3>
            </div>
            <ul className="space-y-4 mb-6">
              {[
                "Initial assessment and planning",
                "Technical requirements",
                "Staff training program",
                "Integration timeline",
              ].map((step, index) => (
                <li key={index} className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-primary" />
                  <span>{step}</span>
                </li>
              ))}
            </ul>
            <Button 
              className="w-full"
              onClick={() => navigate("/enterprise/implementation-guide")}
            >
              View Implementation Guide
            </Button>
          </Card>

          <Card className="p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-primary/10 p-3 rounded-lg">
                <BookOpen className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-2xl font-semibold">Resources</h3>
            </div>
            <ul className="space-y-4 mb-6">
              {[
                "Implementation checklist",
                "Best practices guide",
                "Training materials",
                "Support documentation",
              ].map((resource, index) => (
                <li key={index} className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-primary" />
                  <span>{resource}</span>
                </li>
              ))}
            </ul>
            <Button 
              variant="outline" 
              className="w-full"
              onClick={() => navigate("/enterprise/resources")}
            >
              Access Resources
            </Button>
          </Card>
        </div>
      </div>
    </section>
  );
};